import { sidebarPage } from '../utils/sidebarPageLayout.js';
import { auth, db } from '../../src/firebase.js';
import { collection, addDoc, serverTimestamp } from "firebase/firestore";

const GAMES = [
    {
        emoji: '⚡',
        title: 'Daily Challenge',
        desc: 'New challenges every 24 hours. Boost your Respect Level!',
        status: 'ready',
        overlay: 'Accept Challenge',
        isDaily: true
    },
    {
        emoji: '🧠',
        title: 'Math Brain Trainer',
        desc: 'Beat the clock, solve math problems and climb the global leaderboard!',
        status: 'ready',
        overlay: 'Train Now'
    },
    {
        emoji: '🏆',
        title: 'Championship Memory',
        desc: 'Flip cards to match football icons in this engaging memory game.',
        status: 'ready',
        overlay: 'Play Now'
    },
    {
        emoji: '🌍',
        title: 'World Map',
        desc: "Explore women's football around the world and learn about different countries.",
        status: 'ready',
        overlay: 'Play Now'
    },
    {
        emoji: '⚽',
        title: 'Pitch Panic',
        desc: 'Fast-paced arcade action on the football pitch with obstacles and power-ups.',
        status: 'soon',
        overlay: 'Coming Soon'
    },
    {
        emoji: '⚽',
        title: 'Formation Builder',
        desc: 'Create and test different team formations to build your dream team.',
        status: 'ready',
        overlay: 'Play Now'
    },
    {
        emoji: '❓',
        title: "Women's Football Quiz",
        desc: "Test your knowledge of women's football with challenging questions.",
        status: 'ready',
        overlay: 'Play Now'
    },
    {
        emoji: '🥅',
        title: 'Penalty Shootout',
        desc: 'Score penalties under pressure and test your accuracy skills.',
        status: 'soon',
        overlay: 'Coming Soon'
    },
    {
        emoji: '👥',
        title: 'Team Match',
        desc: 'Match players to their correct teams and test your knowledge.',
        status: 'soon',
        overlay: 'Coming Soon'
    },
    {
        emoji: '📊',
        title: 'Stats Challenge',
        desc: 'Compare player statistics and test your knowledge of football analytics.',
        status: 'soon',
        overlay: 'Coming Soon'
    },
    {
        emoji: '🔮',
        title: 'League Predictor',
        desc: 'Predict match outcomes and test your football intuition.',
        status: 'soon',
        overlay: 'Coming Soon'
    },
    {
        emoji: '👤',
        title: 'Player Guess',
        desc: 'Guess the player from clues and test your knowledge.',
        status: 'soon',
        overlay: 'Coming Soon'
    },
    {
        emoji: '🧠',
        title: 'Football Trivia',
        desc: 'Challenge yourself with football facts and test your knowledge.',
        status: 'soon',
        overlay: 'Coming Soon'
    }
];

function gameCard(g) {
    const statusClass = g.status === 'ready' ? 'fg-game-card__status--ready' : 'fg-game-card__status--soon';
    const statusLabel = g.status === 'ready' ? 'Ready to Play' : 'Coming Soon';
    const dailyClass = g.isDaily ? 'fg-game-card--daily' : '';

    return `
        <article class="fg-game-card ${dailyClass}" data-game="${g.title.replace(/"/g, '&quot;')}" data-status="${g.status}">
            <div class="fg-game-card__media">
                <span aria-hidden="true">${g.emoji}</span>
                <div class="fg-game-card__overlay">${g.overlay}</div>
            </div>
            <div class="fg-game-card__body">
                <div class="fg-game-card__title">${g.title}</div>
                <p class="fg-game-card__desc">${g.desc}</p>
                <span class="fg-game-card__status ${statusClass}">${statusLabel}</span>
            </div>
        </article>
    `;
}

export class Games {
    constructor(containerId) {
        this.containerId = containerId;
    }

    cleanup() {
        // Ensure gaming theme is reset if navigating away
        document.body.classList.remove('fg-theme-gaming');
    }

    init() {
        const el = document.getElementById(this.containerId);
        if (!el) return;

        this.injectStyles();
        const grid = `<div class="fg-games-grid">${GAMES.map(gameCard).join('')}</div>`;

        el.innerHTML = sidebarPage({
            title: '🎮 footballgirl Games',
            subtitle: "Test your knowledge and have fun with women's football!",
            main: grid,
            wide: true
        });

        el.querySelectorAll('.fg-game-card').forEach((card) => {
            card.addEventListener('click', () => {
                if (!auth.currentUser) {
                    // Trigger Universal Auth (Scoped to this module for now)
                    window.alert("Please sign in to your footballgirl account to access Games and track your scores.");
                    return;
                }

                const name = card.getAttribute('data-game');
                const status = card.getAttribute('data-status');
                if (name === 'Math Brain Trainer') {
                    window.dispatchEvent(new CustomEvent('fg:navigate', { detail: { page: 'math-brain-trainer' } }));
                    return;
                }
                if (status === 'ready') {
                    window.alert(`Opening "${name}" — full game integration coming soon!`);
                } else {
                    window.alert(`"${name}" is coming soon!`);
                }
            });
        });
    }

    async saveScore(gameId, score) {
        const user = auth.currentUser;
        if (!user) return;
        try {
            await addDoc(collection(db, 'scores'), {
                userId: user.uid,
                userName: user.displayName || 'Anonymous',
                gameId,
                score,
                timestamp: serverTimestamp()
            });
        } catch (e) { console.error("Score save failed:", e); }
    }

    injectStyles() {
        const styleId = 'fg-games-custom-styles';
        if (document.getElementById(styleId)) return;
        const css = `
            .fg-game-card--daily {
                border: 2px solid #00ff00;
                box-shadow: 0 0 15px rgba(0, 255, 0, 0.2);
                background: rgba(0, 255, 0, 0.02);
            }
            .fg-game-card--daily .fg-game-card__media {
                background: linear-gradient(135deg, #00ff0022, #000);
            }
            .fg-mode-gaming .fg-page { background: #050505; color: #fff; }
            .fg-mode-gaming .fg-game-card { background: #111; border-color: #333; }
            .fg-mode-gaming .fg-game-card__title { color: #fff; }
            .fg-mode-gaming .fg-game-card__desc { color: #aaa; }
        `;
        const style = document.createElement('style');
        style.id = styleId;
        style.textContent = css;
        document.head.appendChild(style);
    }
}
